import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';

import PersonalDetailForm from '../forms/PersonalDetails';
import AboutYourself from '../forms/AboutYourself';

class Personal extends React.Component {

  componentDidMount() {}

  async submitForm() {
    await this.personalDetailForm.submitForm();
    await this.aboutYourselfForm.submitForm();
  }

  render() {
    return (
      <div className="inf-panel">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <div>
            <p className="inf-panel-title">Personal Information</p>
            <p className="inf-panel-sub">Your profile and contact information.</p>
          </div>
          <Button
            variant="contained"
            onClick={() => {
              this.submitForm();
            }}
            style={{ padding: '6px 24px', fontWeight: 700 }}
          >
            Save
          </Button>
        </div>
        <hr className="inf-panel-divider" />

        <Grid container>
          <Grid item xs={12} md={9}>
            <PersonalDetailForm
              onRef={(ref) => (this.personalDetailForm = ref)}
              fieldsToShow={[
                'profile_pic',
                'name',
                'dob',
                'gender',
                'addressLine',
                'state/city',
                'pincode',
              ]}
            />
          </Grid>
        </Grid>

        <p className="inf-panel-title" style={{ marginTop: 34 }}>
          About Yourself
        </p>
        <hr className="inf-panel-divider" />
        <Grid container>
          <Grid item xs={12} md={9}>
            <AboutYourself onRef={(ref) => (this.aboutYourselfForm = ref)} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withRouter(Personal);
